import React from "react";
import "./CMCBio.css";
import PageHeader from "../../components/headers/PageHeader";
import wave from "../../assets/Images/waves/wave_mou.png";

export default function CMCBio() {
    return (
        <div className="cmcbio-page">
            <PageHeader
                mediaSrc={wave}
                mediaType="image"
                subtitle="Biologics CMC Analytics & Regulatory Support"
                title="Statistical Tools for Biologics CMC Analytics"
            />

            <section className="cmcbio-section cmcbio-introSection">
                <h2>Biologics CMC Analytics & Regulatory Support</h2>

                <p>
                    We are developing statistical tools to support Biologics CMC
                    analytics and regulatory support for our valued clients. These
                    solutions are designed to help organizations strengthen analytical
                    validation, stability modelling, process validation, comparability,
                    biosimilar analytics, and regulatory submission readiness.
                </p>

                <p>
                    Our approach combines statistical methodology, regulatory
                    understanding, and practical CMC development needs to support
                    data-driven decision-making across manufacturing, quality,
                    validation, and submission workflows.
                </p>
            </section>

            <section className="cmcbio-section cmcbio-capabilitySection">
                <h2>CMC Statistical Analytics Capabilities</h2>

                <p className="cmcbio-sectionIntro">
                    Our statistical tools and analytics support the following key
                    Biologics CMC areas:
                </p>

                <div className="cmcbio-capabilityGrid">
                    <article className="cmcbio-capabilityCard">
                        Analytical Method Validation
                    </article>

                    <article className="cmcbio-capabilityCard">
                        Stability &amp; Shelf-Life Modelling
                    </article>

                    <article className="cmcbio-capabilityCard">
                        Process Validation &amp; CPV
                    </article>

                    <article className="cmcbio-capabilityCard">
                        QbD &amp; Design Space Development
                    </article>

                    <article className="cmcbio-capabilityCard">
                        Comparability Assessments
                    </article>

                    <article className="cmcbio-capabilityCard">
                        Biosimilar Similarity Analytics
                    </article>

                    <article className="cmcbio-capabilityCard">
                        Statistical Support for PPQ Studies
                    </article>

                    <article className="cmcbio-capabilityCard">
                        CMC Submission Analytics
                    </article>

                    <article className="cmcbio-capabilityCard">
                        Regulatory Response Support
                    </article>

                    <article className="cmcbio-capabilityCard">
                        Manufacturing Trend Analysis
                    </article>
                </div>
            </section>

            <section className="cmcbio-section cmcbio-supportSection">
                <h2>How These Tools Support CMC Decision-Making</h2>

                <div className="cmcbio-cardGrid">
                    <article className="cmcbio-card">
                        <h3>Validation and Method Performance</h3>

                        <p>
                            Statistical evaluation of analytical method performance,
                            precision, accuracy, linearity, range, robustness, and
                            validation readiness.
                        </p>
                    </article>

                    <article className="cmcbio-card">
                        <h3>Stability and Shelf-Life Evaluation</h3>

                        <p>
                            Modelling-based support for stability trends, shelf-life
                            estimation, degradation patterns, and long-term product
                            quality assessment.
                        </p>
                    </article>

                    <article className="cmcbio-card">
                        <h3>Process Validation and Continued Verification</h3>

                        <p>
                            Statistical support for PPQ, process validation, continued
                            process verification, manufacturing consistency, and quality
                            monitoring.
                        </p>
                    </article>

                    <article className="cmcbio-card">
                        <h3>Comparability and Biosimilar Analytics</h3>

                        <p>
                            Quantitative support for comparability assessments,
                            similarity evaluation, analytical bridging, and biosimilar
                            evidence generation.
                        </p>
                    </article>
                </div>
            </section>
        </div>
    );
}